import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { ContentHeader, ContentBody } from 'areas/shared/components'
import TextBoxDemo from './TextBoxDemo'
import CurrencyBoxDemo from './CurrencyBoxDemo'
import DecimalBoxDemo from './DecimalBoxDemo'
import PercentageBoxDemo from './PercentageBoxDemo'
import PhoneBoxDemo from './PhoneBoxDemo'
import EmailBoxDemo from './EmailBoxDemo'
import IntBoxDemo from './IntBoxDemo'
import TextAreaBoxDemo from './TextAreaBoxDemo'
import CheckBoxDemo from './CheckBoxDemo'
import MaskedBoxDemo from './MaskedBoxDemo'
import RadioButtonDemo from './RadioButtonDemo'

const BasicInputs = () => (
	<React.Fragment>
		<ContentHeader id="basicInputs" title="Basic Inputs" description="Basic form controls">
		</ContentHeader>
		<ContentBody>
			<Row>
				<Col md={6}>
					<TextBoxDemo />
				</Col>
				<Col md={6}>
					<MaskedBoxDemo />
				</Col>
			</Row>
            <CurrencyBoxDemo />
			<Row>
				<Col md={6}>
					<PhoneBoxDemo />
				</Col>
				<Col md={6}>
					<DecimalBoxDemo />
				</Col>
			</Row>
			<Row>
				<Col md={6}>
					<EmailBoxDemo />
				</Col>
				<Col md={6}>
					<IntBoxDemo />
				</Col>

			</Row>
			<Row>
				<Col md={6}>
					<PercentageBoxDemo />
				</Col>
				<Col md={6}>
					<TextAreaBoxDemo />
				</Col>
			</Row>
			<Row>
				<Col md={6}>
					<CheckBoxDemo />
				</Col>
				<Col md={6}>
					<RadioButtonDemo />
				</Col>
			</Row>
		</ContentBody>
	</React.Fragment>
)

export default BasicInputs;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/index.js